export default __webpack_public_path__ + "static/media/f.0ec794d7.png";